import { MobileAccountBoxEquitySkeletonStyled } from './styled/MobileAccountBoxStyled';
import amountFormat from '../../../utils/amountFormat';
import { useSelector } from 'react-redux';
import { getGetLiteTradeAccountMetrics } from '../../../modules/LiteTrade/liteTradeSelectors';
import type { IMobileAppRootState } from '../../types/mobileAppState.t';
import { MobileAccountBoxEquityStyled } from './styled/MobileAccountBoxEquityStyled';

function MobileAccountBoxEquity() {
    const equity = useSelector((state: IMobileAppRootState) => {
        const metrics = getGetLiteTradeAccountMetrics(state);
        if (metrics)
            return metrics?.equity || 0;
        return NaN;
    });

    if (isNaN(equity)) {
        return <MobileAccountBoxEquitySkeletonStyled className="wave-background"/>;
    }

    const [beforeDot = '', afterDot = ''] = amountFormat(equity || 0, 2, null, false, { toFixed: true }).split('.');

    return <MobileAccountBoxEquityStyled>
        <p className={'m-0'}><span className={'currency'}>$</span>{beforeDot}<span
            className={'afterDot'}>.{afterDot}</span></p>
    </MobileAccountBoxEquityStyled>;
}

export default MobileAccountBoxEquity;
